
import { Injectable, Injector } from '@angular/core';
import { BaseState } from 'src/app/common/base/base.state'; import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SchedulesCreate, SchedulesDelete, SchedulesRefresh, SchedulesRefreshByID, SchedulesUpdate } from './schedule.action';
import { Schedule } from '../../models/schedule';
import { ScheduleService } from '../../services/schedule.service';
import { ScheduleTypeService } from '../../services/schedule-type.service';
import { EMPTY, catchError, tap } from 'rxjs';

export class SchedulesStateModel {
  data: Schedule[] = [];
  loaded: boolean = false;
  loading: boolean = false;
}

@State<SchedulesStateModel>({
  name: 'Schedules',
  defaults: {
    data: [],
    loaded: false,
    loading: false,
  }
})
@Injectable()
export class SchedulesState extends BaseState {
  constructor(
    protected override injector: Injector,
    private schedulesService: ScheduleService, private scheduleTypeService: ScheduleTypeService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: SchedulesStateModel) {
    return state.data;
  }

  @Action(SchedulesRefresh)
  refresh({ patchState }: StateContext<SchedulesStateModel>) {
    // Assistant schedule questions must not use stale values during a live refresh.
    patchState({ loading: true, loaded: false });

    return this.schedulesService.getAll().pipe(
      tap(data => patchState({ data, loaded: true, loading: false })),
      catchError(error => {
        console.error(error);
        patchState({ loaded: false, loading: false });
        return EMPTY;
      })
    );
  }

  @Action(SchedulesRefreshByID)
  refreshByID({ getState, patchState }: StateContext<SchedulesStateModel>, { id }: SchedulesRefreshByID) {
    this.schedulesService.getById(id).toPromise().then(item => {
      if (item) {
        const state = getState();
        const index = state.data.map(x => x.id).indexOf(id);

        if (index >= 0) {
          state.data.splice(index, 1);
        }

        patchState({
          data: [...state.data, item]
        });
      }
    });

  }

  @Action(SchedulesCreate)
  create({ getState, patchState }: StateContext<SchedulesStateModel>, { item }: SchedulesCreate) {
    patchState({
      data: [...getState().data, item]
    });
  }

  @Action(SchedulesUpdate)
  update({ getState, patchState }: StateContext<SchedulesStateModel>, { id, item }: SchedulesUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(SchedulesDelete)
  delete({ getState, patchState }: StateContext<SchedulesStateModel>, { id }: SchedulesDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id)
    });
  }


}
